import { Button } from "newui/components/Button";
import { Modal } from "newui/components/ui/Modal";

export interface ZeroAllModalProps {
	isOpen: boolean;
	onClose: () => void;
	onZeroAll: () => void;
	onZeroEmpty: () => void;
}

const ZeroAllModal: React.FC<ZeroAllModalProps> = ({
	isOpen,
	onClose,
	onZeroAll,
	onZeroEmpty,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Zero Table Values"
			iconType="warning"
			modalType="standard"
			closeOnEsc
			closeOnOverlayClick
			size="sm"
			customFooter={
				<div className="flex w-full items-center justify-end gap-2">
					<Button btntype="secondary" size="xs" onClick={onClose}>
						Cancel
					</Button>
					<Button btntype="primary" size="xs" onClick={onZeroEmpty}>
						Zero Empty Values
					</Button>
					<Button btntype="danger" size="xs" onClick={onZeroAll}>
						Zero All Values
					</Button>
				</div>
			}
		>
			<div className="text-center font-roboto text-sm text-tertiary-600">
				<p className="mb-2">
					This table has existing values.
				</p>
				<p className="mb-2">How would you like to proceed?</p>
				<div className="text-xs">
					<p>&ldquo;Zero All&rdquo; will overwrite all numeric values.</p>
					<p>&ldquo;Zero Empty&rdquo; will only fill cells that are currently blank.</p>
				</div>
			</div>
		</Modal>
	);
};

export { ZeroAllModal };
